import { FETCH_COMMON_CONFIG } from "../../constants/commonConfig";
import { feeds } from "../../apis/services";

export const getCommonConfig = () => ({
  type: FETCH_COMMON_CONFIG,
  payload: feeds.getCommonConfigV2(),
});
